import type { GetIssueUpdatesByParentIssueIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetIssueUpdatesByParentIssueIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIssueUpdatesByParentIssueIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetIssueUpdateRegisterArgs = { issueId: string };

export const useLazyGetIssueUpdateRegister = createLazyQueryHook<
  UseLazyGetIssueUpdateRegisterArgs,
  GetIssueUpdatesByParentIssueIdResponseRow[],
  GetIssueUpdatesByParentIssueIdQuery
>({
  trpcQuery: (client, { issueId }) =>
    client.frontend.issueUpdate.register.query({
      parentIssueId: issueId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ issue_update: data }),
  graphqlDocument: GetIssueUpdatesByParentIssueIdDocument,
  graphqlVariables: ({ issueId }) => ({ _eq: issueId }),
});
